import {Brick, registerBrick, Service} from 'olympe';
import {SHARED_MEMORY_TOPICS} from '../../../services/service_api/CreateAllRASharedMemory.brick';

/**
 * This brick is responsible for updating the shared memory with
 * Candex session data including a user ID and session ID.
 */
export default class SetInCandexTimeoutMap extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} userId
     * @param {string} sessionId
     * @param {function()} forwardEvent
     */
    update($, [userId, sessionId], [forwardEvent]) {
        Service.publish('allRaSharedMemory', {topic: SHARED_MEMORY_TOPICS.CANDEX_SESSION_ID, userId, sessionId})
            .then(forwardEvent);
    }
}

registerBrick('0197bfb590088f17c8e3', SetInCandexTimeoutMap);
